/**
 * src/data/ExpenseRouletteBank.js
 * Hardcoded scenario bank for Part 9: Expense Roulette.
 */
export const expenseRouletteBank = [
  {
    "id": 1,
    "text": "Upgrading your 6-hour cross-country flight to Business Class using the corporate card because you need to sleep before a client meeting.",
    "correctId": "A",
    "feedback": "Fraud. You cannot upgrade flight classes for personal comfort without explicit, written VP or Finance approval, regardless of flight length."
  },
  {
    "id": 2,
    "text": "Expensing a $12 airport Wi-Fi pass during a two-hour layover to respond to urgent client emails and access the corporate VPN.",
    "correctId": "B",
    "feedback": "Expensable. Purchasing in-transit internet access is a required logistical expense for maintaining business continuity and client communications."
  },
  {
    "id": 3,
    "text": "Expensing a $12 hotel minibar snack because you arrived at 11:30 PM, local restaurants were closed, and you were hungry.",
    "correctId": "A",
    "feedback": "Fraud. Minibar purchases carry prohibitive markups and are categorically excluded from standard T&E policies as personal luxuries. Employees must utilize standard vendors or room service."
  },
  {
    "id": 4,
    "text": "Buying a prospective client a $110 bottle of wine during a closing dinner at a steakhouse to celebrate securing a multi-year contract.",
    "correctId": "B",
    "feedback": "Expensable. Reasonable alcohol consumption during bona fide client entertainment is a customary business generation expense, provided the client is present and the cost aligns with per-head limits."
  },
  {
    "id": 5,
    "text": "Buying your internal project team a $110 bottle of wine at dinner to celebrate a successful software launch, without prior executive approval.",
    "correctId": "A",
    "feedback": "Fraud. Alcohol purchased exclusively for internal team members without an external client present violates standard corporate entertainment policies unless pre-approved by HR/Finance."
  },
  {
    "id": 6,
    "text": "Expensing a $45 dry cleaning bill on day five of a continuous seven-day international business trip.",
    "correctId": "B",
    "feedback": "Expensable. Standard corporate travel policies permit reasonable laundry and dry-cleaning expenses for continuous corporate travel exceeding four consecutive nights to maintain professional attire."
  },
  {
    "id": 7,
    "text": "Expensing a $45 dry cleaning bill on an overnight (1-day) business trip because you spilled coffee on your suit during a turbulent flight.",
    "correctId": "A",
    "feedback": "Fraud. Incidental wardrobe mishaps on short-term travel are personal liabilities. Dry cleaning is only reimbursable for extended, continuous travel."
  },
  {
    "id": 8,
    "text": "Expensing a $35 checked baggage fee for a suitcase containing trade show booth materials and marketing collateral.",
    "correctId": "B",
    "feedback": "Expensable. Logistics and transit costs directly associated with transporting company assets or marketing materials are fully reimbursable operational business expenses."
  },
  {
    "id": 9,
    "text": "Expensing a $75 overweight baggage fee because you packed your personal golf clubs for a free weekend during a two-week business trip.",
    "correctId": "A",
    "feedback": "Fraud. Transporting recreational items for personal use during operational downtime is a personal liability and falls entirely outside the scope of reimbursable travel."
  },
  {
    "id": 10,
    "text": "Expensing a $200 airline change fee because your previous client meeting ran two hours late, causing you to miss your scheduled departure.",
    "correctId": "B",
    "feedback": "Expensable. Fees incurred due to direct, documented, and unavoidable business obligations are valid logistical travel expenses."
  },
  {
    "id": 11,
    "text": "Expensing a $200 airline change fee because you overslept your alarm at the hotel and missed your scheduled morning departure.",
    "correctId": "A",
    "feedback": "Fraud. Corporate budgets do not subsidize personal negligence. Fees incurred due to traveler error are the financial responsibility of the employee."
  },
  {
    "id": 12,
    "text": "Expensing a $55 Uber Black ride because you are traveling with a visiting C-suite executive from a major prospective client.",
    "correctId": "B",
    "feedback": "Expensable. Upgraded transit is permissible when directly accommodating the standard business expectations and professional comfort of external senior executives."
  },
  {
    "id": 13,
    "text": "Expensing a $55 Uber Black ride to the airport because it was raining heavily and the regular UberX queue had a 15-minute wait time.",
    "correctId": "A",
    "feedback": "Fraud. Premium rideshare upgrades for minor conveniences or weather violate standard transit policies. Employees are expected to manage standard travel delays without incurring luxury fees."
  },
  {
    "id": 14,
    "text": "Expensing a $40 solitary dinner for yourself in your home city because you were mandated to stay at the primary office until 9:00 PM for a global earnings call.",
    "correctId": "B",
    "feedback": "Expensable. Overtime meals are generally permissible when an employee is required to work significantly beyond standard business hours at a corporate facility."
  },
  {
    "id": 15,
    "text": "Using the remaining $35 of your daily $75 meal per diem to purchase a Starbucks gift card so you do not lose the unspent daily allowance.",
    "correctId": "A",
    "feedback": "Fraud. Per diems and meal limits are not cash entitlements. Converting unspent T&E limits into cash equivalents or gift cards constitutes financial theft."
  },
  {
    "id": 16,
    "text": "Expensing a $60 municipal parking ticket incurred while you were parked in a loading zone to urgently drop off physical contract documents at a client site.",
    "correctId": "A",
    "feedback": "Fraud. Fines, penalties, and traffic violations are strictly non-reimbursable personal liabilities, even if the infraction occurred while executing corporate duties."
  },
  {
    "id": 17,
    "text": "Submitting a $14 expense for a quick service lunch in an airport terminal where the physical receipt was lost or not provided.",
    "correctId": "B",
    "feedback": "Expensable. Standard IRS and corporate T&E guidelines allow for un-receipted incidental expenses strictly under the $25 threshold for reasonable travel meals."
  },
  {
    "id": 18,
    "text": "Expensing personal vehicle mileage for driving 45 miles from your residence directly to a client's temporary site instead of your normal commute.",
    "correctId": "B",
    "feedback": "Expensable. Travel from a primary residence directly to an off-site client or temporary work location constitutes valid, reimbursable business mileage minus any standard commute deduction."
  },
  {
    "id": 19,
    "text": "Expensing personal vehicle mileage for driving 15 miles from your residence to your primary office because you were mandated to work on a Sunday.",
    "correctId": "A",
    "feedback": "Fraud. Routine commutes between a personal residence and a primary designated workplace are non-reimbursable personal tax liabilities, regardless of the day of the week or overtime status."
  },
  {
    "id": 20,
    "text": "Purchasing the $20 daily supplemental liability insurance at the rental car counter during a routine domestic business trip.",
    "correctId": "A",
    "feedback": "Fraud. The enterprise maintains comprehensive blanket auto liability policies for domestic travel. Counter-purchased insurance is an unauthorized, duplicative expense."
  },
  {
    "id": 21,
    "text": "Purchasing the $20 daily supplemental liability insurance at the rental car counter during an international business trip in a high-risk jurisdiction.",
    "correctId": "B",
    "feedback": "Expensable. Purchasing local supplemental insurance abroad is standard protocol for risk management when corporate umbrella policies possess international jurisdictional exclusions."
  },
  {
    "id": 22,
    "text": "Expensing a $50 late checkout fee at your hotel because your afternoon client meeting was delayed and you required a secure, private Wi-Fi connection for a confidential call.",
    "correctId": "B",
    "feedback": "Expensable. Extended lodging fees incurred to secure private, secure environments for sensitive business communications due to schedule changes are valid operational expenses."
  },
  {
    "id": 23,
    "text": "Expensing a $50 late checkout fee at your hotel because you attended a late-night team dinner and wanted to sleep in before your afternoon flight.",
    "correctId": "A",
    "feedback": "Fraud. Corporate funds do not subsidize personal convenience or recovery time. Fees incurred due to traveler preference or negligence are the employee's responsibility."
  },
  {
    "id": 24,
    "text": "Expensing a $35 seat upgrade to Economy Plus on a domestic flight because you have an HR-documented ergonomic accommodation on file.",
    "correctId": "B",
    "feedback": "Expensable. Upgrades directly tied to documented health, safety, or HR-approved medical accommodations are valid corporate expenses."
  },
  {
    "id": 25,
    "text": "Expensing a $35 seat upgrade to Economy Plus on a domestic flight because you wanted to sit near the front to deplane faster and avoid the rush.",
    "correctId": "A",
    "feedback": "Fraud. Seat upgrades for personal convenience on standard flights violate baseline economy travel policies unless explicitly pre-approved by Finance."
  },
  {
    "id": 26,
    "text": "Purchasing a $75 branded corporate gift basket to send to a key vendor's office to thank them for fulfilling a critical, last-minute supply chain order.",
    "correctId": "B",
    "feedback": "Expensable. Modest, non-cash corporate gifting to a vendor or client entity, within standard nominal thresholds, is an acceptable business relationship management practice."
  },
  {
    "id": 27,
    "text": "Purchasing a $75 Visa prepaid gift card to give to a key vendor's account manager as a thank-you for fulfilling a critical, last-minute supply chain order.",
    "correctId": "A",
    "feedback": "Fraud. Gift cards are classified as cash equivalents by the IRS. Distributing cash equivalents to external parties violates anti-bribery (FCPA) controls and corporate tax policies."
  },
  {
    "id": 28,
    "text": "Including a 20% gratuity on a $150 approved client dinner receipt, bringing the total to $180.",
    "correctId": "B",
    "feedback": "Expensable. Customary gratuities up to 20% on approved business meals are standard business expenses and fully reimbursable under corporate T&E guidelines."
  },
  {
    "id": 29,
    "text": "Including a 45% gratuity on a $50 solo dinner because the total bill was well under your $100 per diem limit and the service was exceptional.",
    "correctId": "A",
    "feedback": "Fraud. Per diems are maximum caps, not discretionary entitlements. Excessive gratuities beyond customary benchmarks (15-20%) constitute a misappropriation of corporate funds."
  },
  {
    "id": 30,
    "text": "Expensing a $45 purchase of emergency medical supplies (bandages, cold packs) to stock the required first-aid kit at your company's remote outdoor trade show booth.",
    "correctId": "B",
    "feedback": "Expensable. Procuring operational health and safety supplies for corporate events, booths, or facilities is a legitimate and required business expense."
  },
  {
    "id": 31,
    "text": "Expensing a $15 box of over-the-counter cold medication purchased at an airport pharmacy because you began experiencing severe symptoms en route to a conference.",
    "correctId": "A",
    "feedback": "Fraud. Personal health, medical, and pharmaceutical items are strictly non-reimbursable personal liabilities, even when illness manifests during active corporate travel."
  },
  {
    "id": 32,
    "text": "Expensing a Saturday night hotel stay because staying over the weekend reduced the Monday return flight cost by $500, resulting in a documented net savings to the company.",
    "correctId": "B",
    "feedback": "Expensable. Extending a stay is permissible when the employee can document absolute net savings to the corporation, typically codified as the 'Saturday Night Rule' exception."
  },
  {
    "id": 33,
    "text": "Expensing a Saturday night hotel stay because your business meetings concluded on Friday afternoon and you wanted to explore the city before flying home Sunday.",
    "correctId": "A",
    "feedback": "Fraud. Accommodation for personal leisure days appended to a business trip ('bleisure') is strictly a personal financial liability and cannot be subsidized by corporate funds."
  },
  {
    "id": 34,
    "text": "Expensing a $25 replacement laptop charger purchased at a local electronics store because yours shorted out right before a major client presentation.",
    "correctId": "B",
    "feedback": "Expensable. Emergency, low-cost operational hardware necessary to ensure immediate business continuity and client delivery during travel is a justifiable T&E expense."
  },
  {
    "id": 35,
    "text": "Expensing a $90-per-head dinner with a local foreign government procurement official to discuss potential municipal contracts.",
    "correctId": "A",
    "feedback": "Fraud. Entertaining foreign government officials carries severe Foreign Corrupt Practices Act (FCPA) risks and violates strict anti-bribery controls without specialized legal pre-clearance."
  },
  {
    "id": 36,
    "text": "Expensing a $50 replacement cost for premium toiletries (shampoo and sunscreen) because TSA confiscated your oversized liquids at the security checkpoint.",
    "correctId": "A",
    "feedback": "Fraud. Replacing personal toiletries confiscated due to traveler negligence or non-compliance with known airport security regulations is a personal financial liability."
  },
  {
    "id": 37,
    "text": "Purchasing a $45 portable power bank at a trade show because your corporate device battery is failing and you must scan attendee lead-capture QR codes.",
    "correctId": "B",
    "feedback": "Expensable. Situational, low-cost hardware accessories required to maintain immediate operational uptime and execute business duties in the field are valid operational expenses."
  },
  {
    "id": 38,
    "text": "Expensing a $35 physical book on enterprise leadership purchased at an airport bookstore to read during your 5-hour flight to a management seminar.",
    "correctId": "A",
    "feedback": "Fraud. Professional development materials must be procured through standard HR or Learning and Development (L&D) purchase orders, not claimed as incidental T&E expenses."
  },
  {
    "id": 39,
    "text": "Expensing a $150 replacement passport fee because you lost your passport during a personal vacation, but you need it for a business trip next week.",
    "correctId": "A",
    "feedback": "Fraud. Passports are baseline personal travel documents. Maintenance and replacement costs resulting from personal negligence remain a personal financial liability, regardless of upcoming corporate travel."
  },
  {
    "id": 40,
    "text": "Expensing a $160 expedited passport processing fee because your manager assigned you to an emergency international deployment departing in 72 hours.",
    "correctId": "B",
    "feedback": "Expensable. Expedited consular, visa, or passport fees are valid logistical expenses when directly necessitated by urgent, short-notice international corporate travel requirements."
  },
  {
    "id": 41,
    "text": "Expensing $120 for a dinner with your spouse who accompanied you on a business trip, because your combined bill remained under your individual $150 daily per diem limit.",
    "correctId": "A",
    "feedback": "Fraud. Per diem limits are maximum caps for the employee's sustenance only, not discretionary funds. Subsidizing a non-employee's meal constitutes personal enrichment and tax fraud."
  },
  {
    "id": 42,
    "text": "Booking a double occupancy hotel room at the same $150 nightly rate as a single room while your spouse accompanies you, and expensing only the $150 room rate.",
    "correctId": "B",
    "feedback": "Expensable. Accompanying companions are permissible provided there is zero incremental cost to the enterprise. Expensing the baseline single-occupancy equivalent rate is valid."
  },
  {
    "id": 43,
    "text": "Expensing a $15 airport shoe shine and a $30 haircut on the morning of your keynote presentation at a major industry conference.",
    "correctId": "A",
    "feedback": "Fraud. Personal grooming, tailoring, and hygiene services are universally classified as non-reimbursable personal liabilities, regardless of high-profile corporate visibility or presentation duties."
  },
  {
    "id": 44,
    "text": "Expensing a $25 entry ticket to a local municipal chamber of commerce mixer where you actively prospected and collected client leads.",
    "correctId": "B",
    "feedback": "Expensable. Admission fees for networking, industry events, or trade shows where the employee is actively executing business development or lead generation are valid operational costs."
  },
  {
    "id": 45,
    "text": "Using your corporate T&E card to pay a $500 independent contractor invoice to bypass the 30-day Accounts Payable cycle and earn a 2% early-pay discount.",
    "correctId": "A",
    "feedback": "Fraud. T&E cards are strictly for travel and entertainment. Using them for vendor invoices circumvents Procure-to-Pay (P2P) financial controls, vendor tax reporting, and AP compliance."
  },
  {
    "id": 46,
    "text": "Expensing a $15 monthly subscription to a premium PDF editor on your corporate card because you needed it once to sign a vendor agreement on the road.",
    "correctId": "A",
    "feedback": "Fraud. Software and SaaS subscriptions must be procured through centralized IT purchasing. Expensing unauthorized 'shadow IT' on a T&E card violates software compliance and security protocols."
  },
  {
    "id": 47,
    "text": "Expensing a $40 working lunch ordered to the office for your team because you required them to work through their designated meal hour to meet a regulatory filing deadline.",
    "correctId": "B",
    "feedback": "Expensable. Providing a working meal is permissible when employees are explicitly required by management to work through standard meal periods to meet urgent operational deadlines."
  },
  {
    "id": 48,
    "text": "Expensing a $5 electronic toll charge incurred on your standard daily commute from your home to your primary assigned office because traffic was unusually heavy.",
    "correctId": "A",
    "feedback": "Fraud. Commuting costs, including tolls, gas, and mileage incurred during a standard trip between a personal residence and a primary tax-home office, are IRS-defined personal liabilities."
  },
  {
    "id": 49,
    "text": "Submitting an expense for a $45 fuel station fill-up on a corporate rental car three miles before returning it to the airport.",
    "correctId": "B",
    "feedback": "Expensable. Refueling a rental vehicle at a standard gas station prior to return is the required standard operating procedure to avoid exorbitant rental agency fuel surcharges."
  },
  {
    "id": 50,
    "text": "Expensing $250 for premium noise-canceling headphones to maintain focus while working on a long-haul corporate flight.",
    "correctId": "A",
    "feedback": "Fraud. Electronic peripherals purchased for personal comfort or focus are personal liabilities unless formally prescribed as an HR or IT workplace accommodation. This bypasses IT procurement."
  }
];